/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext, useEffect, useRef, useState } from "react";
import "./AppPanelHeader.scss";
import OECSLogo from "../../assets/images/logos/OECSLogo.png";
import XIcon from "@material-ui/icons/Close";
import { clearQueryStrings } from "../../hooks/queryString";
import { LayoutContext } from "../../context/LayoutContext";
import { Button, makeStyles } from "@material-ui/core";
import { ChevronLeft } from "@material-ui/icons";

function AppPanelHeader({ title, setApp, hideClose }) {

  const titleDiv = useRef(null);
  const [fontSize, setFontSize] = useState(21);
  const { mobileActive } = useContext(LayoutContext);

  const clearApp = () => {
    clearQueryStrings();
    setApp(null);
  }

  const goBack = () => {
    setApp('intro');
    clearQueryStrings();
  }

  /* Resize font size if wrapping will occur on mobile */
  useEffect(() => {
    if (mobileActive && titleDiv) {
      const titleWidth = titleDiv.current.offsetWidth;
      const parentWidth = parseFloat(window.getComputedStyle(titleDiv.current.parentElement).width);
      const parentPadRight = parseFloat(window.getComputedStyle(titleDiv.current.parentElement).paddingRight);
      if (titleWidth > (parentWidth - parentPadRight)) {
        setFontSize(fontSize * parentWidth / titleWidth);
      }
      else {
        setFontSize(21);
      }
    }
  }, [window.innerWidth, titleDiv?.current?.offsetWidth, title]);

  const useStyles = makeStyles({
    buttonLabel: {
      fontFamily: 'Lato',
      textTransform: 'uppercase',
      fontWeight: '700',
      letterSpacing: '0.8px',
    }
  });

  const classes = useStyles();

  return (
    <>
      <header className="appPanelHeader" style={{ fontSize: fontSize }}>
        {title === 'Get Started' && (
          <img
            className="oecsLogo"
            src={OECSLogo}
            alt="Organisation of Eastern Caribbean States"
            title="Organisation of Eastern Caribbean States"
          />
        )}
        <div className="text" ref={titleDiv}>
          {title}
        </div>

        <div onClick={() => clearApp()} to="/" className="appPanelHeaderX">
          <XIcon hidden={hideClose || mobileActive}></XIcon>
        </div>
      </header>
      {title !== 'Get Started' && mobileActive && (
        <Button
          classes={{
            label: classes.buttonLabel
          }}
          onClick={goBack}>
          <ChevronLeft /> Back
        </Button>
      )}
    </>
  );
}

export default AppPanelHeader;
